import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  ALL_DISPLAY_COLUMNS,
  formatColumnName,
  formatCellValue,
} from "../utils/columnConfig";

const DetailModal = ({ open, details, onClose, userManufacturer }) => {
  // Filter columns to display (exclude year/quarter from detail view, optionally manufacturer)
  const displayColumns = ALL_DISPLAY_COLUMNS.filter((col) => {
    if (col === "year" || col === "quarter") return false;
    if (col === "manufacturer" && userManufacturer !== "ciita") return false;
    return true;
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          maxHeight: "80%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          overflow: "auto",
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Entry Details
        </Typography>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {displayColumns.map((col) => (
                  <TableCell key={col} sx={{ fontWeight: "bold" }}>
                    {formatColumnName(col)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {details.map((detail, index) => (
                <TableRow key={detail.id || index}>
                  {displayColumns.map((col) => {
                    // 🔑 CRITICAL FIX: Ensure the value is passed as a string
                    // to guarantee the formatCellValue logic sees a string input.
                    const cellValue = detail[col];

                    return (
                      <TableCell key={col}>
                        {formatCellValue(
                          col === "created_at" && cellValue
                            ? String(cellValue)
                            : cellValue,
                          col
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Button onClick={onClose} sx={{ mt: 2 }} variant="contained">
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default DetailModal;
